import { Observers } from "./Observers"
export default function () {
	return { Observers }
}
